import { useState } from "react";
import { track } from "../utils/analytics";
import { SAMPLE_REPORT_URL } from "./SampleReport";

// One tap under the buy button tells us why a reader didn't buy, since with
// so few buyers the numbers alone can't. Only the choice is stored.
export const NOT_NOW_REASONS = [
  { id: "price", label: "Too expensive" },
  { id: "accuracy", label: "Not sure it's accurate" },
  { id: "later", label: "Maybe later" },
  { id: "other", label: "Something else" },
];

export default function NotNowReasons({ requestId }) {
  const [chosen, setChosen] = useState("");

  function choose(reason) {
    setChosen(reason);
    track("not_now_reason", { requestId, reason });
  }

  if (chosen) {
    return (
      <div role="status" className="rounded-2xl bg-green-50 p-4 text-sm text-green-900 ring-1 ring-green-200 space-y-1.5">
        <p className="font-semibold">Thank you, that really helps.</p>
        <p className="text-green-800">The 14-page sample shows exactly how a report reads, so you can judge for yourself.</p>
        <a href={SAMPLE_REPORT_URL} target="_blank" rel="noopener noreferrer"
          onClick={() => track("sample_report_view", { requestId })}
          className="inline-block font-semibold text-orange-700 hover:underline">
          Read the sample →
        </a>
      </div>
    );
  }

  return (
    <div className="border-t border-gray-100 pt-4 space-y-2.5">
      <p className="text-sm font-medium text-gray-800 text-center">Not today? One tap tells us why.</p>
      <div className="flex flex-wrap justify-center gap-2">
        {NOT_NOW_REASONS.map((r) => (
          <button key={r.id} type="button" onClick={() => choose(r.id)}
            className="rounded-full border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-700 hover:border-orange-400 focus:outline-none focus:ring-2 focus:ring-orange-500">
            {r.label}
          </button>
        ))}
      </div>
    </div>
  );
}
